import React, { useState, useEffect } from 'react';
import Chip from '@material-ui/core/Chip';

const SelectableTags = ({ data, isClickable = true }) => {
  const [isActive, setIsActive] = useState({});

  useEffect(() => {
    if (data.value) {
      const temp = {};
      data.value.forEach((item) => {
        temp[item] = true;
      });
      setIsActive({
        ...isActive,
        ...temp,
      });
    }
  }, []);

  return (
    <div>
      {data.values.map((item, idx) => {
        return (
          <Chip
            variant="outlined"
            clickable={isClickable}
            style={{ margin: 5 }}
            key={`${item}_${idx}`}
            id={item}
            value={item}
            color="primary"
            label={item}
          />
        );
      })}
    </div>
  );
};

export default SelectableTags;
